import { Declassifica } from "src/app/shared/models/declassifica.model";
import { Versamento } from "src/app/shared/models/versamento.model";

export enum OperazioneMassivaTipo
{
    Distruzione = 0,
    Declassifica = 1,
    Versamento = 2,
}

export interface OperazioneMassivaCommon
{
    tipo: OperazioneMassivaTipo;
    dataOperazione: Date;
    dati: string;
    numDocumenti: number;
    numeroVerbale: string;
}

export interface OperazioneMassivaRegistro {    
    numeroOrdine:number;
    dataRegistro : Date;
    classificaQualifica: string;
}

export interface OperazioneMassivaResponse extends OperazioneMassivaCommon
{
    operazioneId : number;
    registro: OperazioneMassivaRegistro | null;
}


export interface OperazioneMassivaRequest<T> extends OperazioneMassivaCommon
{
    documentoIds: number[];
    attributi: T;
}

export interface DistruzioneAttributi
{     
    data: string | null;
    mezzo: string;
    numeroNota: string;
    salvaSuRegistro: boolean;
}

export type OperazioneMassivaDistruzioneRequest = OperazioneMassivaRequest<DistruzioneAttributi>;
export type OperazioneMassivaDeclassificaRequest = OperazioneMassivaRequest<Declassifica>;
export type OperazioneMassivaVersamentoRequest = OperazioneMassivaRequest<Versamento>;

export interface DistruzioneBulkResponse {
    numeroOrdine: number;
    operazioneId : number;
}

export enum DestroyReportFileFormat {
    Word = 0,
    PDF = 1
} 